import _ from 'underscore';
import { filterOutCampaignAndAdgroupName } from '../utils';

function updateEntitySchemaForNetwork({
  entitySchema,
  i18n,
  scope,
}) {
  let entitySchemaCopy = entitySchema;

  entitySchemaCopy.properties.Network = {
    property: 'Network',
    name: i18n.getString('ColumnName_Network'),
    title: i18n.getString('ColumnName_Network'),
    enumType: 'Network',
    enum: [0, 1, 2, 3, 4, 5],
    type: 'string',
    enumValueMap: {
      0: i18n.getString('Dimension_Network_0'),
      1: i18n.getString('Dimension_Network_1'),
      2: i18n.getString('Dimension_Network_2'),
      3: i18n.getString('Dimension_Network_3'),
      4: i18n.getString('Dimension_Network_4'),
      5: i18n.getString('Dimension_Network_5'),
    },
    chooseType: 'checkbox',
    filterable: true,
  };

  entitySchemaCopy = filterOutCampaignAndAdgroupName(scope, entitySchemaCopy);

  return entitySchemaCopy;
}

export class DimensionsPublisherWebsiteSchemaProcessor {
  constructor(options) {
    this.i18n = options.i18n;
    this.scope = options.scope;
  }

  updateEntitySchemaForFeatures(entitySchema) {
    const updateEntitySchema = {
      properties: {
      },
    };

    _.each(entitySchema.properties, (schema) => {
      updateEntitySchema.properties[schema.originalProperty] = schema;
    });

    updateEntitySchema.name = entitySchema.name;

    updateEntitySchemaForNetwork({
      entitySchema: updateEntitySchema,
      i18n: this.i18n,
      scope: this.scope,
    });
    return updateEntitySchema;
  }
}
